import styled from 'styled-components';
import { Checkbox } from '../../fields/Checkbox';

export const Container = styled.div`
  max-width: 270px;
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-radius: 12px;
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
`;

export const StyledCheckbox = styled(Checkbox)`
  font-size: 18px;
`;
